import { FC } from 'react';
import colors from 'constants/colors';
import { Image } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';
import Icon, { IconNames } from 'components/Icon';
import { IRecipients } from 'store/recipients/types';

interface Props {
  candidates: IRecipients[];
  impactScoreVisibility: boolean;
}

export const ListRecipients: FC<Props> = ({ candidates, impactScoreVisibility }) => {
  return (
    <>
      {candidates.map((rec, index) => (
        <div key={index} className="candidate-container">
          <div className="candidate-values">
            <div className="check-circle">
              <Icon name={IconNames.Check} size={8} color={colors.white} />
            </div>
            <Image
              alt={`Recipient ${rec.recipient_name}`}
              src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${rec.misc_ids?.photo_id}.jpg`}
              fallbackImgType="candidate_square"
            />
            <div className="candidate-name">
              <div className="inkBlue">{rec.recipient_name}</div>
              <div className="gray">{rec.race?.election.display_info}</div>
              <div className="gray">{rec.race?.election.state}</div>
            </div>
          </div>
          {impactScoreVisibility && (
            <div className="oath-preview-text oathBlue">{rec.impact_score}</div>
          )}
        </div>
      ))}
    </>
  );
};
